import { render } from "./Embed.vue?vue&type=template&id=27f0a265"
import script from "./Embed.vue?vue&type=script&lang=js"
export * from "./Embed.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/Embed.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "27f0a265"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('27f0a265', __exports__)) {
    api.reload('27f0a265', __exports__)
  }
  
  module.hot.accept("./Embed.vue?vue&type=template&id=27f0a265", () => {
    api.rerender('27f0a265', render)
  })

}


export default __exports__